<template>
  <BoxCard>
    <template #header>
      <div class="flex justify-between">
        <p>Invitation</p>
        <ViceBadge v-if="invitationDetails.user_role == 'participant'" indigo icon="UserIcon">
          {{ invitationDetails.user_role }}
        </ViceBadge>
        <ViceBadge v-else yellow icon="EyeIcon">
          {{ invitationDetails.user_role }}
        </ViceBadge>
      </div>
    </template>

    <template #content>
      <div class="mb-5">
        <p>You have been invited to attend the session as a {{ invitationDetails.user_role }}</p>
      </div>
      <div class="relative w-full mx-5">
        <hr class="absolute right-6 w-full text-gray-200" />
      </div>
      <div class="mt-12 flex gap-4 justify-center step-accept-invitation">
        <ViceButton data-cy="accept-invitation" icon="CheckIcon" @click="acceptInvitation">
          Accept invitiation
        </ViceButton>
      </div>
    </template>
  </BoxCard>
</template>

<script>
import { ref } from 'vue';
import axios from 'axios';
// import { Inertia } from '@inertiajs/inertia';
import ViceBadge from '@/Components/Badges/ViceBadge.vue';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import BoxCard from '@/Components/Cards/BoxCard.vue';
import useTourManager from '@/Composables/useTourManager';
import { userInvitationTourSteps } from '@/Data/tourSteps';

const userInvitationTour = useTourManager('userInvitationTour', userInvitationTourSteps);

export default {
  name: 'Application',
  components: {
    BoxCard,
    ViceButton,
    ViceBadge,
  },
  setup() {
    const userTypeSelected = ref(null);
    return {
      userTypeSelected,
    };
  },
  mounted() {
    setTimeout(() => {
      userInvitationTour.startTour();
    }, 500);
  },
  props: {
    userSessionType: String,
  },
  data() {
    return {
      invitationAccepted: false,
    };
  },
  methods: {
    acceptInvitation() {
      axios.post(this.acceptInvitationUrl).then(() => {
        this.invitationAccepted = true;
        window.location.reload();
      });
    },
  },
  computed: {
    invitationDetails() {
      return this.$page.props.session.invites.find(
        (invitation) => invitation.email == this.$page.props.user.email,
      );
    },
    acceptInvitationUrl() {
      if (this.invitationDetails) {
        return route('session.accept_invitation', [
          this.invitationDetails.token,
          this.invitationDetails.email,
        ]);
      }
      // eslint-disable-next-line no-script-url
      return 'javascript:void(0)';
    },
  },
};
</script>

<style scoped></style>
